
export enum DisputeShpIneligibilityRsnCd {
	INVOICE_NOT_FULLY_PAID = 'InvoiceNotFullyPaid',
	PICKUP_DATE_GREATER_THAN_180_DAYS = 'PickupDateGreaterThan180Days'}

